import React, { useState } from 'react';
import { _T } from "../../../../../base-react/src/Localization";
import { Button, Card, List, Space, Typography, Form, Input } from 'antd';
import { DeleteOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons';
const { Paragraph } = Typography;
export const FloorCard = (props) => {
    const { item, onAddItem, onDeleteItem, onEditItem, childFloors, disabled } = props;
    const [isLoading, setIsLoading] = useState(false);
    const [editingFloorId, setEditingFloorId] = useState(null); // Track the currently editing floor ID
    const [form] = Form.useForm();
    const handleSave = async () => {
        try {
            const values = await form.validateFields();
            setIsLoading(true);
            await onEditItem({ ...item, ...values });
            setEditingFloorId(null); // Close editing mode
            setIsLoading(false);
        }
        catch (error) {
            console.error("Validation failed:", error);
        }
    };
    const handleAddItem = async () => {
        try {
            setIsLoading(true);
            const newItem = { floor_name: '', floor_code: '', floor_parent_id: item.floor_id };
            await onAddItem(newItem);
            setIsLoading(false);
        }
        catch (error) {
            console.error("Failed to add item:", error);
            setIsLoading(false);
        }
    };
    function handleChangeName(child, text) {
        const updatedChild = { ...child, floor_name: text };
        onEditItem(updatedChild);
    }
    ;
    function handleChangeCode(child, text) {
        const updatedChild = { ...child, floor_code: text };
        onEditItem(updatedChild);
    }
    ;
    return (React.createElement(Card, { style: { width: 300 }, extra: React.createElement(Space, null,
            React.createElement(Button, { onClick: () => { var _a; return setEditingFloorId(editingFloorId === item.floor_id ? null : (_a = item.floor_id) !== null && _a !== void 0 ? _a : null); }, icon: React.createElement(EditOutlined, null), disabled: disabled }),
            React.createElement(Button, { type: 'dashed', onClick: () => onDeleteItem(item), icon: React.createElement(DeleteOutlined, null), disabled: disabled })), title: editingFloorId === item.floor_id ? (React.createElement(Form, { form: form, initialValues: { floor_name: item.floor_name, floor_code: item.floor_code }, style: { paddingTop: 12, paddingBottom: 12 } },
            React.createElement(Form.Item, { name: "floor_name", rules: [{ required: true, message: _T('common.required') }] },
                React.createElement(Input, { placeholder: _T('floor.details.floor_name'), disabled: disabled })),
            React.createElement(Form.Item, { name: "floor_code", extra: _T('floor.details.floor_code.extra') },
                React.createElement(Input, { placeholder: "Floor Code", disabled: disabled })),
            React.createElement(Button, { type: "primary", onClick: handleSave, loading: isLoading, disabled: disabled }, _T('common.save')))) : (React.createElement(React.Fragment, null,
            React.createElement(Paragraph, null,
                item.floor_name,
                " ",
                item.floor_code && `(${item.floor_code})`))) },
        childFloors.length > 0 &&
            React.createElement(List, { dataSource: childFloors, renderItem: (child) => (React.createElement(List.Item, { actions: [
                        React.createElement(Button, { onClick: () => { var _a; return setEditingFloorId(editingFloorId === child.floor_id ? null : (_a = child.floor_id) !== null && _a !== void 0 ? _a : null); }, icon: React.createElement(EditOutlined, null), disabled: disabled }),
                        React.createElement(Button, { type: 'dashed', onClick: () => onDeleteItem(child), icon: React.createElement(DeleteOutlined, null), disabled: disabled })
                    ] }, editingFloorId === child.floor_id ? (React.createElement(Form, { initialValues: { floor_name: child.floor_name, floor_code: child.floor_code }, style: { paddingTop: 12, paddingBottom: 12 } },
                    React.createElement(Form.Item, { name: "floor_name", rules: [{ required: true, message: _T('common.required') }] },
                        React.createElement(Input, { placeholder: _T('floor.details.floor_name.label'), disabled: disabled, onChange: (e) => handleChangeName(child, e.target.value) })),
                    React.createElement(Form.Item, { name: "floor_code" },
                        React.createElement(Input, { placeholder: _T('floor.details.floor_code.label'), disabled: disabled, onChange: (e) => handleChangeCode(child, e.target.value) })))) : (React.createElement(Paragraph, null,
                    child.floor_name,
                    " ",
                    child.floor_code && `(${child.floor_code})`)))) }),
        React.createElement(Button, { onClick: handleAddItem, icon: React.createElement(PlusOutlined, null), loading: isLoading, disabled: disabled }, _T('common.create', { name: _T('floor.section').toLocaleLowerCase() }))));
};
